// Docs / References
//
// OpenSea API for collection
// https://api.opensea.io/api/v1/assets?collection=goodmorningcafe&owner=0x9EB2DD513b007646B10a019f11481F9eB69DB77c
//
// React-konvas
// https://konvajs.org/docs/react/index.html
//
// Autoconnect wallet
// https://github.com/aragon/use-wallet
//
// Confirmation popup
// https://github.com/nicolas-van/react-bootstrap-confirmation
//
// Global context
// https://github.com/betula/use-between


// React components
import React, {useEffect, useState} from 'react'

// Bootstrap declarations
import Container from 'react-bootstrap/Container';

// Use-wallet for account management 
import { UseWalletProvider, useWallet } from 'use-wallet'

// Context modules
import { useSharedGlobalState } from "./shared/GlobalState";
import { useSharedNavigationFunctions } from "./shared/NavigationFunctions";
import { useSharedNavigationPageGlobalState } from "./shared/NavigationPageGlobalState";
import { useSharedDataManipulationFunctions } from "./shared/DataManipulationFunctions";
import { useSharedCollectionsMetadata } from "./partner/CollectionsMetadata";

// App Components
import OpenseaStats from './components/OpenseaStats.js';
import CollectionExplorer from './components/collectionExplorer/CollectionExplorer.js';








//
//
//
// ---------------------------
// PARTNER SPECIFIC RESSOURCES
// ---------------------------
//
//
//


//
// ************
// BANNER MAKER
// ************
//

// -----------
// Demo setups
// -----------

import DemoBackgroundgenerator from './partner/_DEMO/BackgroundGeneratorConfig.js';
import DemoHeaderBanner from './partner/_DEMO/HeaderBanner.js';
import DemoHeaderGallery from './partner/_DEMO/HeaderGallery.js';
import DemoFooter from './partner/_DEMO/Footer.js';
//import DemoHeaderExplorer from './partner/WHISKERS/HeaderExplorer.js';

// -----------------
// Production setups
// -----------------

// Productions - Good morning Cafe (2022-01)
import GmcBackgroundgenerator from './partner/GMC/BackgroundGeneratorConfig.js';
import GmcHeader from './partner/GMC/Header.js';
import GmcFooter from './partner/GMC/Footer.js';

// Productions - Kitty Cones (2022-04)
import KcBackgroundgenerator from './partner/KC/BackgroundGeneratorConfig.js';
import KcHeader from './partner/KC/Header.js';
import KcFooter from './partner/KC/Footer.js';

// Productions - Wonderpals (2022-09) 
import WpBackgroundgenerator from './partner/WP/BackgroundGeneratorConfig.js';
import WpHeader from './partner/WP/Header.js';
import WpFooter from './partner/WP/Footer.js';

// Productions - Whiskers (2022-09)
import WhiskersBackgroundgenerator from './partner/WHISKERS/BackgroundGeneratorConfig.js';
import WhiskersHeader from './partner/WHISKERS/Header.js';
import WhiskerCardGeneratorHeader from './partner/WHISKERS/HeaderCardGenerator.js';
import WhiskersFooter from './partner/WHISKERS/Footer.js';

// Productions - Killa Bears (2023-04)
import KbBackgroundgenerator from './partner/KB/BackgroundGeneratorConfig.js';
import KbHeader from './partner/KB/HeaderBanner.js';
import KbFooter from './partner/KB/Footer.js';


// -----------------
// Not in Production
// -----------------

// Moonbirds - Need to reach out 
import MoonbirdsProofBackgroundgenerator from './partner/MOONBIRDS/PROOF/BackgroundGeneratorConfig.js';
import MoonbirdsDbsBackgroundgenerator from './partner/MOONBIRDS/DBS/BackgroundGeneratorConfig.js';
import MoonbirdsProofHeader from './partner/MOONBIRDS/PROOF/Header.js';
import MoonbirdsDbsHeader from './partner/MOONBIRDS/DBS/Header.js';
import MoonbirdsProofFooter from './partner/MOONBIRDS/PROOF/Footer.js';
import MoonbirdsDbsFooter from './partner/MOONBIRDS/DBS/Footer.js';

// Chubbyland - Was not ready to commit
import ChubbyBackgroundgenerator from './partner/CHUBBY/BackgroundGeneratorConfig.js';
import ChubbyHeader from './partner/CHUBBY/Header.js';
import ChubbyFooter from './partner/CHUBBY/Footer.js';

// Kumo - Was not ready to commit
// import KumoHeader from './partner/KUMO/Header.js';
// import KumoFooter from './partner/KUMO/Footer.js';
// import KumoBackgroundgenerator from './partner/KUMO/BackgroundGeneratorConfig.js';

// Little Lemons Friends - Pending Finalization (2022-09)
import LlfBackgroundgenerator from './partner/LLF/BackgroundGeneratorConfig.js';
import LlfHeader from './partner/LLF/Header.js';
import LlfFooter from './partner/LLF/Footer.js';

// Renga - Did not found an agreement (2022-10)
import RengaHeader from './partner/RENGA/Header.js';
import RengaFooter from './partner/RENGA/Footer.js';
import RengaBackgroundgenerator from './partner/RENGA/BackgroundGeneratorConfig.js';



//
// *******
// GALLERY
// *******
//     

// -----------------
// Not in Production
// -----------------

// Good Morning Cafe - Need to reach out 
import GmcHeaderExplorer from './partner/GMC/HeaderExplorer.js';

// Whiskers - Need to reach out
import WHiskersHeaderExplorer from './partner/WHISKERS/HeaderExplorer.js';



//
// **************
// CARD GENERATOR (PROTOTYPE)
// **************
//     

// Whiskers - WIP
import WhiskersCardGenerator from './partner/WHISKERS/CardGeneratorConfig.js';








//
//
//    
// ----------------
// MAIN APPLICATION
// ----------------
//
//
//

const Application = () => {

    // Handle Metamask connection 
    const wallet = useWallet();
    const [userWalletAddress, setUserWalletAddress] = useState("0x2A275B6280534124bfb0Ca70cb8C1a47a4f22B5b");
    
    // Retrieve items from context --------------------------------------------------
    // Global states
    const { 
        env_APP_MODE, env_RUNTIME_MODE,
        setUserIsAdmin,
        errorMessage, setErrorMessage,
        setDefaultAccount,
        setWalletConnected,
        OPENSEA_API_KEY
    } = useSharedGlobalState();
    // DataManipulation functions
    const { 
        getAssetIdFromSqweakerCollectionTokenId,
        getAssetIdFromGoodMorningCafeCollectionTokenId,
        getAssetIdFromKittyConeClassicCollectionTokenId,
        getAssetIdFromKillaBearsCollectionTokenId,
        getAssetIdFromChubbyLandNFTCollectionTokenId,
        getAssetIdFromWonderPalsCollectionTokenId,
        getAssetIdFromRengaCollectionTokenId,
        getAssetIdFromWhiskersCollectionTokenId,
        getAssetIdFromLittleLemonFriendsCollectionTokenId,
        getAssetIdFromMoonbirdsCollectionTokenId,
        // getAssetIdFromKumoWorldCollectionTokenName,
    } = useSharedDataManipulationFunctions();
    // Navigation functions
    const { 
        setUserHasCow,                                  // TODO: Move somewhere else
    } = useSharedNavigationFunctions();
    // Global nav
    const { 
        selectedNavItem, 
        setOwnerAvailableCows,
        setOwnerAvailableCowsNFT,
        setHasUserSelectedACow,
        ownerWalletAddress, setOwnerWalletAddress,      // User wallet address to prevent querying user collection multiple time 
        setOpenseaCollectionData
    } = useSharedNavigationPageGlobalState();
    // Collections metadata
    const { 

        // Demo configuration
        DEMO_COLLECTION_DETAILS,
        DEMO_COLLECTION_ASSET_DIRECTORY,
        DEMO_COLLECTION_ASSET_DIRECTORY_THUMBNAILS,
        // Demo - Collection explorer configuration 
        DEMO_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND,
        DEMO_COLLECTION_METADATA_ASSETS,
        DEMO_COLLECTION_METADATA_TRAITS,
        
        // Good Morning Cafe - Background configuration 
        GMC_OG_COLLECTION_DETAILS,
        GMC_OG_COLLECTION_ASSET_DIRECTORY,
        GMC_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS,
        // Good Morning Cafe - Collection explorer configuration 
        GMC_OG_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND,
        GMC_OG_COLLECTION_METADATA_ASSETS,
        GMC_OG_COLLECTION_METADATA_TRAITS,

        // Kitty Cones Classic - Background configuration 
        KC_OG_COLLECTION_DETAILS,
        KC_OG_COLLECTION_ASSET_DIRECTORY,
        KC_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS,
        // Kitty Cones Classic - Collection explorer configuration 
        KC_OG_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND,
        KC_OG_COLLECTION_METADATA_ASSETS,
        KC_OG_COLLECTION_METADATA_TRAITS,

        // KillaBears - Background configuration 
        KB_OG_COLLECTION_DETAILS,
        KB_OG_COLLECTION_ASSET_DIRECTORY,
        KB_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS,
        // KillaBears - Collection explorer configuration 
        //KB_OG_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND,
        //KB_OG_COLLECTION_METADATA_ASSETS,
        //KB_OG_COLLECTION_METADATA_TRAITS,

        // Kitty Cones Collection - Background configuration 
        KC_5K_COLLECTION_DETAILS,
        // KC_5K_COLLECTION_ASSET_DIRECTORY,
        // Kitty Cones Collection - Background configuration 
        KC_5K_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND,
        KC_5K_COLLECTION_METADATA_ASSETS,
        KC_5K_COLLECTION_METADATA_TRAITS,

        // Chubby Lands - Background configuration 
        CHUBBY_OG_COLLECTION_DETAILS,
        CHUBBY_OG_COLLECTION_ASSET_DIRECTORY,

        // Kumo 
        // KUMOWORLD_COLLETION_ASSET_DIRECTORY

        // MOONBIRDS - Background configuration 
        PROOF_MOONBIRDS_COLLECTION_DETAILS,
        PROOF_MOONBIRDS_COLLECTION_ASSET_DIRECTORY,
        PROOF_MOONBIRDS_COLLECTION_ASSET_DIRECTORY_THUMBNAILS,
        // MOONBIRDS - Background configuration 
        // PROOF_MOONBIRDS_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND,
        // PROOF_MOONBIRDS_COLLECTION_METADATA_ASSETS,
        // PROOF_MOONBIRDS_COLLECTION_METADATA_TRAITS,

        // WonderPals - Background configuration 
        WONDERPALS_OG_COLLECTION_DETAILS,
        WONDERPALS_OG_COLLECTION_ASSET_DIRECTORY,
        WONDERPALS_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS,
        // WonderPals - Background configuration 
        // WONDERPALS_OG_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND,
        // WONDERPALS_OG_COLLECTION_METADATA_ASSETS,
        // WONDERPALS_OG_COLLECTION_METADATA_TRAITS,

        // WHISKERS - Background configuration 
        WHISKERS_OG_COLLECTION_DETAILS,
        WHISKERS_OG_COLLECTION_ASSET_DIRECTORY,
        WHISKERS_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS,
        // WHISKERS - Collection explorer configuration 
        WHISKERS_OG_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND,
        WHISKERS_OG_COLLECTION_METADATA_ASSETS,
        WHISKERS_OG_COLLECTION_METADATA_TRAITS,

        // Little Lemon Friends - Background configuration 
        LLF_OG_COLLECTION_DETAILS,
        LLF_OG_COLLECTION_ASSET_DIRECTORY,
        LLF_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS,
        // Little Lemon Friends - Background configuration 
        // LLF_OG_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND,
        // LLF_OG_COLLECTION_METADATA_ASSETS,
        // LLF_OG_COLLECTION_METADATA_TRAITS,

        // Renga - Background configuration 
        RENGA_OG_COLLECTION_DETAILS,
        RENGA_OG_COLLECTION_ASSET_DIRECTORY,
        RENGA_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS,
        // Renga - Background configuration 
        // RENGA_OG_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND,
        // RENGA_OG_COLLECTION_METADATA_ASSETS,
        // RENGA_OG_COLLECTION_METADATA_TRAITS,

    } = useSharedCollectionsMetadata();
    // Retrieve items from context --------------------------------------------------

    

    // Handle wallet events 
    useEffect(() => {
        //console.log("In useEffet = wallet");
        if (wallet.status === 'connected' && wallet.account) {
            //console.log("Setting up wallet and loading NFT own... Wallet addr:" + wallet.account);
            setHasUserSelectedACow(false);
            setDefaultAccount(wallet.account);
            setWalletConnected(true);
            lookupNFTCustomWallet(wallet.account);
        } 

        if (wallet.status !== 'connected') {
            setHasUserSelectedACow(false);
            setDefaultAccount(null);
            setWalletConnected(false);
            setOwnerAvailableCows([]);
            setOwnerAvailableCowsNFT(0);
            setOwnerWalletAddress(null);
            setUserHasCow(false);

            // Generate asset for the active implementaion  
            // generateAvailableAsset();

            // Behavior when user has not connected its wallet
            // These are usually instance for which we want to update the default behavior
            // When we do not offer to the user to connect its wallet
            if ((env_APP_MODE === "MOONBIRDS-PROOF")) {
                setUserHasCow(true);
            }
            if ((env_APP_MODE === "MOONBIRDS-DBS")) {
                setUserHasCow(true);
            }

        }
        if (wallet.error?.name) {
            setErrorMessage("Can't connect to you wallet! In order for us to read your wallet information, you need to install the MetaMask extension.");
        }
        //console.log("Is wallet connected? " + walletConnected);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wallet]);

    // Handle wallet events 
    useEffect(() => {
        if (ownerWalletAddress !== "" && ownerWalletAddress !== null) {
            setHasUserSelectedACow(false);
            lookupNFTCustomWallet(ownerWalletAddress);
        } 

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ownerWalletAddress]);


    /**
     * Function that lookup the NFT for the current collection for a specific user wallet 
     * @param {*} walletAddr the wallet to lookup NFT for the collection from 
     */
    function lookupNFTCustomWallet(walletAddr) {

        console.log("lookupNFTCustomWallet: lookingup content of wallet: " + walletAddr + " with APP_MODE=" + env_APP_MODE);

        if ((env_APP_MODE === "DEMO-BANNER")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(DEMO_COLLECTION_DETAILS.collectionName, walletAddr, DEMO_COLLECTION_ASSET_DIRECTORY, "Sqweaker #", false);
        }
        if ((env_APP_MODE === "DEMO-GALLERY")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(DEMO_COLLECTION_DETAILS.collectionName, walletAddr, DEMO_COLLECTION_ASSET_DIRECTORY, "Sqweaker #", false);
        }
        if ((env_APP_MODE === "GMC")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(GMC_OG_COLLECTION_DETAILS.collectionName, walletAddr, GMC_OG_COLLECTION_ASSET_DIRECTORY, "Highland #", false);
        }
        if ((env_APP_MODE === "GMC-EXPLORER")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(GMC_OG_COLLECTION_DETAILS.collectionName, walletAddr, GMC_OG_COLLECTION_ASSET_DIRECTORY, "Highland #", false);
        }
        if ((env_APP_MODE === "KC")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(KC_OG_COLLECTION_DETAILS.collectionName, walletAddr, KC_OG_COLLECTION_ASSET_DIRECTORY, "KittyCone #", false);
        }
        if ((env_APP_MODE === "KB")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(KB_OG_COLLECTION_DETAILS.collectionName, walletAddr, KB_OG_COLLECTION_ASSET_DIRECTORY, "KillaBear #", false);
        }
        if ((env_APP_MODE === "CHUBBY")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(CHUBBY_OG_COLLECTION_DETAILS.collectionName, walletAddr, CHUBBY_OG_COLLECTION_ASSET_DIRECTORY, "ChubbyLand #", false);
        }
        // if ((env_APP_MODE === "KUMO")) {
        //     if (ownerWalletAddress === null) {
        //         setOwnerWalletAddress(walletAddr);
        //     }
        //         openseaCollectionLookup("goodmorningcafe", walletAddr, KUMOWORLD_COLLETION_ASSET_DIRECTORY, "Kumo Resident #", false);
        // }
        if ((env_APP_MODE === "MOONBIRDS-PROOF")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(PROOF_MOONBIRDS_COLLECTION_DETAILS.collectionName, walletAddr, PROOF_MOONBIRDS_COLLECTION_ASSET_DIRECTORY, "Moonbirds #", true);
        }
        if ((env_APP_MODE === "MOONBIRDS-DBS")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(PROOF_MOONBIRDS_COLLECTION_DETAILS.collectionName, walletAddr, PROOF_MOONBIRDS_COLLECTION_ASSET_DIRECTORY, "(DBS) Moonbirds #", true);
        }
        if ((env_APP_MODE === "WP")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(WONDERPALS_OG_COLLECTION_DETAILS.collectionName, walletAddr, WONDERPALS_OG_COLLECTION_ASSET_DIRECTORY, "WonderPals #", false);
        }
        if ((env_APP_MODE === "WHISKERS")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(WHISKERS_OG_COLLECTION_DETAILS.collectionName, walletAddr, WHISKERS_OG_COLLECTION_ASSET_DIRECTORY, "Whiskers #", false);
        }
        if ((env_APP_MODE === "WHISKERS-EXPLORER")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(WHISKERS_OG_COLLECTION_DETAILS.collectionName, walletAddr, WHISKERS_OG_COLLECTION_ASSET_DIRECTORY, "Whiskers #", false);
        }
        if ((env_APP_MODE === "WHISKERS-CARDS")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(WHISKERS_OG_COLLECTION_DETAILS.collectionName, walletAddr, WHISKERS_OG_COLLECTION_ASSET_DIRECTORY, "Whiskers #", false);
        }
        if ((env_APP_MODE === "LLF")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(LLF_OG_COLLECTION_DETAILS.collectionName, walletAddr, LLF_OG_COLLECTION_ASSET_DIRECTORY, "Little Lemon Friends #", false);
        }
        if ((env_APP_MODE === "RENGA")) {
            if (ownerWalletAddress === null) {
                setOwnerWalletAddress(walletAddr);
            }
            openseaCollectionLookup(RENGA_OG_COLLECTION_DETAILS.collectionName, walletAddr, RENGA_OG_COLLECTION_ASSET_DIRECTORY, "Renga #", false);
        }  

    }


    // OPENSEA
    // *******
        
    // Looking OS Collection NFTs that belong to ownerAddress
    // ------------------------------------------------------
    
    // Function 
    // API: https://api.opensea.io/api/v1/assets?collection=goodmorningcafe&owner=

    // ForceUserHasCow - if True, we set that boolean to true. This is used to circumvent access to wallet to unlock specific access to opensea statistic page 

    async function openseaCollectionLookup(collectionName, ownerAddress, assetDirectory, assetPrefix, forceUserHasCow) { 

        console.log("openseaCollectionLookup: Wallet address to process: " + ownerAddress);
        
        const formData = new FormData();
        formData.append("X-API-KEY", OPENSEA_API_KEY);

        const fetchUrl = 'https://api.opensea.io/api/v1/assets?collection=' + collectionName + '&owner=' + ownerAddress + '&limit=200';
        const nftArray = await fetch(fetchUrl, {method: 'GET', headers: formData})
            .then(response => response.json());
        // NOTE - We are assuming fetch return results!
        if (nftArray.length === 0) {
            // TODO Handle error here
            console.err("No data retrieve from fetch call: " + fetchUrl);
        } else {

            let myCowNftCollectionArray = [];
            let availableCowsArray = [];        // Array of NFTs that can be selected and later placed on the canvas
    
            //console.log("Query Result=", nftArray);
            let results = nftArray;
            if (results.length === 0) {

                console.log("No NFT found in user wallet. Addr=" + ownerAddress);

                if (forceUserHasCow) {
                    setUserHasCow(true);
                } else {
                    setUserHasCow(false);
                }
            } else {
                setUserHasCow(true);

                // TODO: Migrate this code to be partner specific

                if (
                       ownerAddress === "0x9EB2DD513b007646B10a019f11481F9eB69DB77c"        // Myself 
                    ) {
                    setUserIsAdmin(true);
                } else {
                    setUserIsAdmin(false);
                }

                if (nftArray.assets !== undefined) {

                    //console.log("Parsing assets from wallet...");
                    nftArray.assets.forEach(eachNFT => {
                        
                        let assetNumber = null; let assetFileName = null; let asset = null;
                        let thumbnailDirectory = null;

                        if (collectionName === DEMO_COLLECTION_DETAILS.collectionName) {
                            console.log("Found an asset that belong to DEMO Sqweaker Collection: ", eachNFT);
                            asset = getAssetIdFromSqweakerCollectionTokenId(eachNFT.token_id);
                            assetFileName = asset.fileName;
                            assetNumber = asset.assetIndexNumber;
                        }
                        else if (collectionName === GMC_OG_COLLECTION_DETAILS.collectionName) {
                            console.log("Found an asset that belong to GMC OG Collection: ", eachNFT);
                            asset = getAssetIdFromGoodMorningCafeCollectionTokenId(eachNFT.token_id);
                            assetFileName = asset.fileName;
                            assetNumber = asset.assetIndexNumber;
                        }
                        else if (collectionName === KC_OG_COLLECTION_DETAILS.collectionName) {
                            console.log("Found an asset that belong to KC OG Collection: " + eachNFT.name);
                            asset = getAssetIdFromKittyConeClassicCollectionTokenId(eachNFT.token_id);
                            assetFileName = asset.fileName;
                            assetNumber = asset.assetIndexNumber;
                        }
                        else if (collectionName === KB_OG_COLLECTION_DETAILS.collectionName) {
                            console.log("Found an asset that belong to KB OG Collection: " + eachNFT.name);
                            asset = getAssetIdFromKillaBearsCollectionTokenId(eachNFT.token_id);
                            assetFileName = asset.fileName;
                            assetNumber = asset.assetIndexNumber;
                        }
                        else if (collectionName === CHUBBY_OG_COLLECTION_DETAILS.collectionName) {
                            console.log("Found an asset that belong to CHUBBYLAND Collection: " + eachNFT.name);
                            asset = getAssetIdFromChubbyLandNFTCollectionTokenId(eachNFT.token_id);
                            assetFileName = asset.fileName;
                            assetNumber = asset.assetIndexNumber;
                        } 
                        // else if (collectionName === "kumo-x-world-residents") {
                        //     assetId = getAssetIdFromKumoWorldCollectionTokenName(eachNFT.name);
                        // }
                        else if (collectionName === PROOF_MOONBIRDS_COLLECTION_DETAILS.collectionName) {
                            console.log("Found an asset that belong to MOONBIRDS Collection: " + eachNFT.name);
                            asset = getAssetIdFromMoonbirdsCollectionTokenId(eachNFT.token_id);
                            assetFileName = asset.fileName;
                            assetNumber = asset.assetIndexNumber;
                            thumbnailDirectory = PROOF_MOONBIRDS_COLLECTION_ASSET_DIRECTORY_THUMBNAILS;
                        }
                        else if (collectionName === WONDERPALS_OG_COLLECTION_DETAILS.collectionName) {
                            console.log("Found an asset that belong to WONDERPAL Collection: " + eachNFT.name);
                            asset = getAssetIdFromWonderPalsCollectionTokenId(eachNFT.token_id);
                            assetFileName = asset.fileName;
                            assetNumber = asset.assetIndexNumber;
                            thumbnailDirectory = WONDERPALS_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS;
                        }
                        else if (collectionName === WHISKERS_OG_COLLECTION_DETAILS.collectionName) {
                            console.log("Found an asset that belong to WHISKERS Collection: " + eachNFT.name);
                            asset = getAssetIdFromWhiskersCollectionTokenId(eachNFT.token_id);
                            assetFileName = asset.fileName;
                            assetNumber = asset.assetIndexNumber;
                            thumbnailDirectory = WHISKERS_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS;
                        }
                        else if (collectionName === LLF_OG_COLLECTION_DETAILS.collectionName) {
                            console.log("Found an asset that belong to LLF Collection: " + eachNFT.name);
                            asset = getAssetIdFromLittleLemonFriendsCollectionTokenId(eachNFT.token_id);
                            assetFileName = asset.fileName;
                            assetNumber = asset.assetIndexNumber;
                            thumbnailDirectory = LLF_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS;
                        }

                        else if (collectionName === RENGA_OG_COLLECTION_DETAILS.collectionName) {
                            console.log("Found an asset that belong to RENGA Collection: " + eachNFT.name);
                            asset = getAssetIdFromRengaCollectionTokenId(eachNFT.token_id);
                            assetFileName = asset.fileName;
                            assetNumber = asset.assetIndexNumber;
                            thumbnailDirectory = RENGA_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS;
                        }
                        else {
                            console.error("Code not implemented for collection: " + collectionName);
                        }

                        const localFile = assetDirectory + assetFileName;
                        let localThumbnail = null;
                        if (thumbnailDirectory !== null) {
                            localThumbnail = thumbnailDirectory + assetFileName; 
                        } else {
                            localThumbnail = localFile;
                        }
                        eachNFT.image_local_file_transparent = localFile;
                        myCowNftCollectionArray.push(eachNFT);
                        // Create an array with only the information we need about the cow 
                        // customCowNumberToAddToCollectionthat belong to the user wallet 
                        availableCowsArray.push(
                            {
                                id: 'assetId' + assetNumber,
                                image_local_file_transparent: localFile,
                                image_local_file_thumbnail: localThumbnail,
                                name: assetPrefix + assetNumber,
                                tokenId: eachNFT.token_id,
                                scale: 1,              // -1 to flip the cow
                                addedToCanvas: false  // Allow to only add the cow once to the canvas
                            }
                        );
                    })
                    setOwnerAvailableCowsNFT(availableCowsArray.length);

                    // Add one more cow for people that want more cows
                    // With placeholders cows
                    if (collectionName === GMC_OG_COLLECTION_DETAILS.collectionName) {
                        // Unavailable cow
                        const localFile = GMC_OG_COLLECTION_ASSET_DIRECTORY + "HL_needCow.png";
                        availableCowsArray.push(
                            {
                                id: 'assetId' + availableCowsArray.length,
                                image_local_file_transparent: null,         // Set to null as we do not want to add this image to the canvas
                                image_local_file_thumbnail: localFile,
                                name: "Need more? Check the collection on Opensea!",
                                tokenId: -1,
                                scale: 1,            // -1 to flip the cow
                                addedToCanvas: true  // Allow to only add the cow once to the canvas
                            }
                        );
                    }

                    //console.log("NOW myCowNftCollectionArray: ", myCowNftCollectionArray);
                    //console.log("NOW availableCowsArray: ", availableCowsArray);
                    setOpenseaCollectionData(myCowNftCollectionArray);
                    setOwnerAvailableCows(availableCowsArray);

                } else {

                    console.error("Invalid User Wallet Address: " + ownerAddress);

                }
            }

        }

    };

    return (

    <>

        
        {(env_RUNTIME_MODE === "DEV") && (<div className="gmcApp developer-mode"><strong>WARNING: Developer mode</strong></div> )}

        <div className="gmcApp container-fluid d-flex flex-column vh-100 mh-100 overflow-hidden">
    
            {/* APP HEADER */}
            <div className="row flex-shrink-1">
                {(env_APP_MODE === "DEMO-BANNER") && (              <DemoHeaderBanner /> )}
                {(env_APP_MODE === "DEMO-GALLERY") && (             <DemoHeaderGallery /> )}
                {(env_APP_MODE === "GMC") && (                      <GmcHeader /> )}
                {(env_APP_MODE === "KC") && (                       <KcHeader /> )}
                {(env_APP_MODE === "KB") && (                       <KbHeader /> )}
                {(env_APP_MODE === "CHUBBY") && (                   <ChubbyHeader /> )}  
                {/* {(env_APP_MODE === "KUMO") && (                 <KumoHeader /> )} */}
                {(env_APP_MODE === "MOONBIRDS-PROOF") && (          <MoonbirdsProofHeader /> )}
                {(env_APP_MODE === "MOONBIRDS-DBS") && (            <MoonbirdsDbsHeader /> )}
                {(env_APP_MODE === "WP") && (                       <WpHeader /> )}
                {(env_APP_MODE === "WHISKERS") && (                 <WhiskersHeader /> )}
                {(env_APP_MODE === "LLF") && (                      <LlfHeader /> )}
                {(env_APP_MODE === "RENGA") && (                    <RengaHeader /> )}
                
                {(env_APP_MODE === "GMC-GALLERY") && (              <GmcHeaderExplorer /> )}
                {(env_APP_MODE === "WHISKERS-GALLERY") && (         <WHiskersHeaderExplorer /> )}
                {(env_APP_MODE === "WHISKERS-CARDS") && (           <WhiskerCardGeneratorHeader /> )}
                
                {/* This is for all level errors (like Metamask not installed) */}
                { errorMessage && 
                    <Container>
                        <div className="m-2 alert alert-danger">{errorMessage}</div>    
                    </Container>
                }
            </div>

            {/*OPENSEA STATS COLLECTION PAGE */}
            {selectedNavItem.includes("STATS_COLLECTION_") && 

                <div className="row flex-grow-1 overflow-hidden">
                    <div id="col-left" className="col-12 mh-100 overflow-auto">
                        <OpenseaStats />
                    </div>
                </div>

            }

            {/* APP EXPLORER COLLECTION PAGE */}
            {selectedNavItem.includes("EXPLORER_COLLECTION_") &&  
                        <>
                        {(env_APP_MODE === "DEMO-GALLERY") && (
                            <CollectionExplorer 
                            collectionMetadataAssets={DEMO_COLLECTION_METADATA_ASSETS}
                            collectionMetadataTraits={DEMO_COLLECTION_METADATA_TRAITS}
                            collectionAssetsHighresDirectory={DEMO_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND}
                            collectionAssetsThumbnailsDirectory={DEMO_COLLECTION_ASSET_DIRECTORY_THUMBNAILS}
                            collectionName={DEMO_COLLECTION_DETAILS.collectionName}
                            />
                        )}
                        {(env_APP_MODE === "GMC-GALLERY") && (
                            <CollectionExplorer 
                            collectionMetadataAssets={GMC_OG_COLLECTION_METADATA_ASSETS}
                            collectionMetadataTraits={GMC_OG_COLLECTION_METADATA_TRAITS}
                            collectionAssetsHighresDirectory={GMC_OG_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND}
                            collectionAssetsThumbnailsDirectory={GMC_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS}
                            collectionName={GMC_OG_COLLECTION_DETAILS.collectionName}
                            />
                        )}
                        {(env_APP_MODE === "KC") && (
                            <CollectionExplorer 
                            collectionMetadataAssets={KC_OG_COLLECTION_METADATA_ASSETS}
                            collectionMetadataTraits={KC_OG_COLLECTION_METADATA_TRAITS}
                            collectionAssetsHighresDirectory={KC_OG_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND}
                            collectionAssetsThumbnailsDirectory={KC_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS}
                            collectionName={KC_OG_COLLECTION_DETAILS.collectionName}
                            />
                        )}
                        {(env_APP_MODE === "KC5K") && (
                            <CollectionExplorer 
                            collectionMetadataAssets={KC_5K_COLLECTION_METADATA_ASSETS}
                            collectionMetadataTraits={KC_5K_COLLECTION_METADATA_TRAITS}
                            collectionAssetsHighresDirectory={KC_5K_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND}
                            collectionAssetsThumbnailsDirectory={DEMO_COLLECTION_ASSET_DIRECTORY_THUMBNAILS}
                            collectionName={KC_5K_COLLECTION_DETAILS.collectionName}
                            />
                        )}
                        {(env_APP_MODE === "WHISKERS-GALLERY") && (
                            <CollectionExplorer 
                            collectionMetadataAssets={WHISKERS_OG_COLLECTION_METADATA_ASSETS}
                            collectionMetadataTraits={WHISKERS_OG_COLLECTION_METADATA_TRAITS}
                            collectionAssetsHighresDirectory={WHISKERS_OG_COLLECTION_ASSET_DIRECTORY_WITHBACKGROUND}
                            collectionAssetsThumbnailsDirectory={WHISKERS_OG_COLLECTION_ASSET_DIRECTORY_THUMBNAILS}
                            collectionName={WHISKERS_OG_COLLECTION_DETAILS.collectionName}
                            />
                        )}
                        </>
            }

            {/* APP BACKGROUND GENERATOR PAGE */}
            {(selectedNavItem === "BACKGROUND_GENERATOR_NOT_GATED") && 
                <>
                <div className="row flex-grow-1 overflow-hidden">
                    <div className="col-12 mh-100 overflow-auto">

                        {/* Background generator */}
                        {(env_APP_MODE === "DEMO-BANNER") &&        <DemoBackgroundgenerator />}
                        {(env_APP_MODE === "GMC") &&                <GmcBackgroundgenerator />}
                        {(env_APP_MODE === "KC") &&                 <KcBackgroundgenerator />}
                        {(env_APP_MODE === "KB") &&                 <KbBackgroundgenerator />}
                        {(env_APP_MODE === "CHUBBY") &&             <ChubbyBackgroundgenerator />}
                        {/* {(env_APP_MODE === "KUMO") &&           <KumoBackgroundgenerator />}  */}
                        {(env_APP_MODE === "MOONBIRDS-PROOF") &&    <MoonbirdsProofBackgroundgenerator /> }
                        {(env_APP_MODE === "MOONBIRDS-DBS") &&      <MoonbirdsDbsBackgroundgenerator /> }
                        {(env_APP_MODE === "WP") &&                 <WpBackgroundgenerator /> }
                        {(env_APP_MODE === "WHISKERS") &&           <WhiskersBackgroundgenerator /> }
                        {(env_APP_MODE === "LLF") &&                <LlfBackgroundgenerator /> }
                        {(env_APP_MODE === "RENGA") &&              <RengaBackgroundgenerator /> }
                        
                        {/* Card Generator */}
                        {(env_APP_MODE === "WHISKERS-CARDS") &&           <WhiskersCardGenerator /> }
                        
                     </div>
                </div>
                </>
            }

            {/* APP FOOTER */}
            <div className="row flex-shrink-1">
                {(env_APP_MODE === "DEMO-BANNER") && (              <DemoFooter /> )}
                {(env_APP_MODE === "DEMO-GALLERY") && (             <DemoFooter /> )}
                {(env_APP_MODE === "GMC") && (                      <GmcFooter /> )}
                {(env_APP_MODE === "GMC-GALLERY") && (              <GmcFooter /> )}
                {(env_APP_MODE === "KC") && (                       <KcFooter /> )}
                {(env_APP_MODE === "KB") && (                       <KbFooter /> )}
                {(env_APP_MODE === "CHUBBY") && (                   <ChubbyFooter /> )}
                {/* {(env_APP_MODE === "KUMO") && (                 <KumoFooter /> )}  */}
                {(env_APP_MODE === "MOONBIRDS-PROOF") && (          <MoonbirdsProofFooter /> )}
                {(env_APP_MODE === "MOONBIRDS-DBS") && (            <MoonbirdsDbsFooter /> )}
                {(env_APP_MODE === "WP") && (                       <WpFooter /> )}
                {(env_APP_MODE === "WHISKERS") && (                 <WhiskersFooter /> )}
                {(env_APP_MODE === "WHISKERS-CARDS") && (           <WhiskersFooter /> )}
                {(env_APP_MODE === "WHISKERS-GALLERY") && (         <WhiskersFooter /> )}
                {(env_APP_MODE === "LLF") && (                      <LlfFooter /> )}
                {(env_APP_MODE === "RENGA") && (                    <RengaFooter /> )}
            </div>
        </div>
  </>

  )

}

// Wrap everything in <UseWalletProvider />
export default () => (
    <UseWalletProvider
        autoConnect
        connectors={{
            injected: {
                //allows you to connect to mainnet within Metamask.
                chainId: [1],
            },
            walletlink: {
                chainId: 1,
                url: 'https://mainnet.eth.aragon.network/',
            },
            walletconnect: {
                rpc: {
                  1: 'https://mainnet.infura.io/v3/a0d8c94ba9a946daa5ee149e52fa5ff1'
                },
                bridge: 'https://bridge.walletconnect.org',
                pollingInterval: 12000,
              },
        }}>
        <Application />
    </UseWalletProvider>
)